import { Platform } from '@angular/cdk/platform';

import { Constants } from '@helper/constants';
import { StaticPages } from '@helper/static-pages';

export class AppHelper {
  private static APP_REDIRECT_DEBOUNCE = 200;

  static isIPad(): boolean {
    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  }

  static isAndroidPad(platform: Platform): boolean {
    return !platform.ANDROID && navigator.platform.includes('Linux') && navigator.maxTouchPoints > 1;
  }

  static isFBAgent(): boolean {
    return (window.navigator.userAgent || '').includes('FB');
  }

  static isWechat(): boolean {
    const agent = (window.navigator.userAgent || '').toLowerCase();
    return agent.includes('wechat') || agent.includes('weixin') || agent.includes('micromessenger');
  }

  static isLineAgent(): boolean {
    return (window.navigator.userAgent || '').toLowerCase().includes('line');
  }

  static isIGAgent(): boolean {
    return (window.navigator.userAgent || '').toLowerCase().includes('instagram');
  }

  static openApp(platform: Platform, isShareApp = false): void {
    const originUrl = window.location.href;
    const isFB = AppHelper.isFBAgent();

    // 塞 pid 到 query params.
    const urlParams = new URLSearchParams(window.location.search);
    let url = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
    if (platform.ANDROID || AppHelper.isAndroidPad(platform)) {
      const intent = url.replace(window.location.protocol, 'intent:').split('#')[0];
      window.location.href = `${intent}#Intent;scheme=${Constants.APP_PACKAGE_SCHEME};package=${Constants.ANDROID_PACKAGE_NAME};end`;
    } else if (platform.IOS || AppHelper.isIPad()) {
      // domain = 'lativprod://www.lativ.com.tw'
      const domain = window.location.origin.replace(window.location.protocol, `${Constants.APP_PACKAGE_SCHEME}:`);
      url = `${domain}${window.location.pathname}?${urlParams.toString()}`;
      if ((platform.WEBKIT && !platform.SAFARI) || (isFB && isShareApp)) {
        window.location.href = url;
        setTimeout(() => {
          if (window.location.href !== originUrl) {
            return;
          }
          window.location.href = Constants.IOS_REDIRECT_URL;
          window.history.replaceState('', '', originUrl);
        }, this.APP_REDIRECT_DEBOUNCE);
      } else if (isFB) {
        // ios open app link url.
        window.location.href = `${Constants.LINK_URL_HOST}/OpenApp?link=${encodeURI(url)}`;
      } else {
        // ios universal link url.
        window.location.href = url;
        setTimeout(() => {
          if (window.location.href !== originUrl) {
            return;
          }
          window.location.href = Constants.IOS_REDIRECT_URL;
          window.history.replaceState('', '', originUrl);
        }, this.APP_REDIRECT_DEBOUNCE);
      }
    } else {
      window.open(`${Constants.LINK_URL_HOST}/page/${StaticPages.appDownload}`);
    }
    window.history.replaceState('', '', originUrl);
  }

  static openAppInThirdParty(platform: Platform, url: string, force: boolean = false): void {
    if (!AppHelper.isLineAgent() && !AppHelper.isIGAgent() && !force) {
      return;
    }
    if (platform.ANDROID || AppHelper.isAndroidPad(platform)) {
      const intent = url.replace('https', 'intent').split('#')[0];
      window.location.href = `${intent}#Intent;scheme=${Constants.APP_PACKAGE_SCHEME};S.browser_fallback_url=${url};end`;
    } else if (platform.IOS || AppHelper.isIPad()) {
      // domain = 'lativprod://www.lativ.com.tw'
      window.location.href = url.replace('https', Constants.APP_PACKAGE_SCHEME);
    }
  }
}
